import SessionEvent from 'session/SessionEvent.js';
import {PARAMETER_CHANGE} from 'session/constants.js';

class ParameterChangeEvent extends SessionEvent {
    constructor(parameter, value) {
        super();
        this.parameter = parameter;
        this.parameterValue = value;
    }

    getCopy() {
        return new ParameterChangeEvent()
            .fromJson(this.getJson());
    }

    isSkippable() {
        return true;
    }

    executeEvent(sequencerEngine) {
        if (this.parameter) {
            this.parameter.set(this.parameterValue, true);
        }
    }

    getJson() {
        if (this.parameter === undefined) {
            return undefined;
        }
        return {
            ... super.getJson(),
            parameter: this.parameter.getJson(),
            value: this.parameterValue,
        };
    }

    getType() {
        return PARAMETER_CHANGE;
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.parameter = sequencerEngine.getParameterFromJson(json.parameter);
        this.parameterValue = json.value;
        if (this.parameter === undefined) {
            return undefined;
        }
        return this;
    }
}

export default ParameterChangeEvent;

